import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-treatment-philosophy-card',
  imports: [
    NgIf
  ],
  templateUrl: './treatment-philosophy-card.component.html',
  standalone: true,
})
export class TreatmentPhilosophyCardComponent {
  @Input('card') card: any;
  @Input('expanded') expanded: boolean = false;
  @Output() collapsedCardClick: EventEmitter<any> = new EventEmitter();
  @Output() onCardClose: EventEmitter<void> = new EventEmitter();

  cardClick(id: number): void {
    this.collapsedCardClick.emit(id);
  }

  closeCard(): void {
    this.onCardClose.emit();
  }
}
